module.exports = __webpack_public_path__ + "img/pin10.fdf7b5ed.png";